import { Button, DialogContent, Stack, Typography } from '@mui/material';
import DialogAdaptive from '../common/DialogAdaptive';
import StyledCardTitleBar from '../common/StyledCardTitleBar';
import StyledDialogActions from '../common/StyledDialogActions';
import TextFieldClipboard from '../common/TextFieldClipboard';

type Props = {
    open: boolean;
    onClose: () => void;
    subscriberUsername: string;
    cognitoUsername: string | null;
    email: string | null;
    loading: boolean;
    error: string | null;
};

const CognitoEmailLookupDialog = (props: Props) => {
    const { open, onClose, subscriberUsername, cognitoUsername, email, loading, error } = props;

    return (
        <DialogAdaptive open={open} onClose={onClose} fullWidth maxWidth="sm">
            <StyledCardTitleBar title="Cognito Email" />
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <Typography variant="body2">
                        OnlyFans account: <strong>{subscriberUsername}</strong>
                    </Typography>

                    {cognitoUsername && (
                        <Typography variant="body2" sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>
                            Cognito username: {cognitoUsername}
                        </Typography>
                    )}

                    {loading && <Typography variant="body2">Looking up Cognito email...</Typography>}

                    {error && (
                        <Typography variant="body2" color="error">
                            {error}
                        </Typography>
                    )}

                    {!loading && !error && email && <TextFieldClipboard label="Cognito Email" value={email} />}

                    {!loading && !error && email === null && cognitoUsername && (
                        <Typography variant="body2" color="text.secondary">
                            No email on file for this Cognito user.
                        </Typography>
                    )}
                </Stack>
            </DialogContent>
            <StyledDialogActions>
                <Button onClick={onClose}>Close</Button>
            </StyledDialogActions>
        </DialogAdaptive>
    );
};

export default CognitoEmailLookupDialog;
